import React from 'react';
import pinIcon from '../../assets/Home/pinIcon.svg';
import loadingIcon from "../../assets/Home/loading.png";
import { useAuth } from '../../context/AuthContext';
import { NemuContext } from '../../utils/NemuContext';
import { api } from '../../context/Auth';
import axios from 'axios';

function Card(props) {
  const { selectedProp, setSelectedProp } = React.useContext(NemuContext);
  const [pinning, setPinning] = React.useState(false);
    const { setMyProjects } = useAuth();

  const isSelected = selectedProp === props.id;

  const formatDateHour = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  const handleTogglePinned = async () => {
    try {
      setPinning(true);
      const response = await axios.patch(`${api}/development/togglePrivate/${props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      console.log(response);
      
      if (response.data.success) {
        console.log("XDASDASD");
        
        setMyProjects((prevProjects) =>
          prevProjects.map((project) =>
            project.id === props.id ? { ...project, is_private: !project.is_private } : project
          )
        );
        // Aquí puedes manejar la respuesta si es necesario
      setPinning(false);
      } else {
        console.error('Error al alternar el estado de fijado:', response.data.message);
      }
    } catch (error) {
      console.error('Error al alternar el estado de fijado:', error);
      setPinning(false);
    }
  }

  const getStatusColor = (status) => {
    if (status === "Publicado") return "bg-[#E6F2D1] border-[#129B12] text-[#129B12]";
    if (status === "Borrador") return "bg-[#E5E1FC] border-[#4C63ED] text-[#4C63ED]";
    if (status === "Vendido") return "bg-[#FFF3E0] border-[#E65100] text-[#E65100]";
  }

  return (
    <div 
      onClick={() => setSelectedProp(props.id)} 
      className={`cursor-pointer flex flex-col items-start w-[100%] ${isSelected ? 'bg-[#4C63ED1F]' : 'bg-white'} rounded-[4px] py-[12px] px-[16px] gap-[8px] transition-all duration-300 ${props.pinned ? 'order-0' : 'order-1'}`}>
      <div className='flex w-[100%] items-center justify-between'>
        <div className='flex gap-[4px]'>
          <span className={`flex border-[1px] h-min rounded-[24px] py-[4px] px-[8px] text-[12px] ${getStatusColor(props.published)}`}>
            {props.published}
          </span>
          {/* <span className='flex border-[1px] h-min border-black rounded-[24px] py-[4px] px-[8px] text-[12px] '>87/180</span> */}
        </div>
        <button disabled={pinning} onClick={() => handleTogglePinned()} className={`cursor-pointer flex gap-[12px] hover:bg-gray-300 p-2 rounded-full ${props.pinned ? 'bg-white invert' : ''}`}>
          <img src={pinning ? loadingIcon : pinIcon} alt='Pin icon' className={`w-4 h-4 ${pinning ? 'animate-spin' : ''}`} />
        </button>
      </div>
      <div className='flex flex-col items-start '>
        <span className='flex text-[20px] text-start'>{props.title}</span>
        <span className='text-[12px] '>{props.location}</span>
      </div>
      <span className='text-[12px] '>última act: {formatDateHour(props.date)}</span>
    </div>
  );
}

export { Card };

function getStatusColor(status) {
  if (status === "Publicado")
    return { border: "#129B12", bgcolor: "#E6F2D1" };
  if (status === "Borrador") return { border: "#4C63ED", bgcolor: "#E5E1FC" };
  if (status === "Cerrado")
    return { border: "#282827", bgcolor: "transparent" };
  if (status === "Error")
    return { border: "#FF6F43", bgcolor: "transparent" };
  if (status === false) return { border: "#FF6F43", bgcolor: "transparent" };
  if (status === true) return { border: "#FF6F43", bgcolor: "transparent" };
  return { border: "#FF6F43", bgcolor: "transparent" };
}